import Form from './Form'
import FormFooter from './FormFooter'
import FormField, { StripeFormField } from './FormField'
import FormLabel from './FormLabel'
import FormError from './FormError'
import FormErrorField from './FormErrorField'

export default Object.assign(Form, {
  Footer: FormFooter,
  Field: FormField,
  StripeField: StripeFormField,
  Label: FormLabel,
  Error: FormError,
  ErrorField: FormErrorField,
})
